import { render } from "./QuotesTable.vue?vue&type=template&id=d70e20c6&scoped=true"
import script from "./QuotesTable.vue?vue&type=script&lang=js"
export * from "./QuotesTable.vue?vue&type=script&lang=js"

import "./QuotesTable.vue?vue&type=style&index=0&id=d70e20c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d70e20c6"]])

export default __exports__